import * as React from "react"

function SmallArrow(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={10}
      height={6}
      viewBox="0 0 10 6"
      {...props}
    >
      <path
        d="M4.857 0L.237 4.449a.758.758 0 000 1.1L4.857 10 6 8.9 1.952 5 6 1.1z"
        transform="rotate(90 5 5)"
      />
    </svg>
  )
}

export default SmallArrow